<footer class="footer flex alignCenter center">
  Powered by Noise Diagnosis v.3.3.0
  <div class="privacy hoverable" (click)="openPrivacyPolicy()">Privacy Policy(KR)</div>
</footer>

<footer class="footer">
  <div class="container">
    <span class="text-muted">Powered by Noise Diagnosis {{ version }} </span>
    <button class="privacy-button" (click)="openPrivacyPolicy()">개인정보 처리방침 (Privacy Policy) </button>
  </div>
</footer>
